import { useEffect } from 'react'

function AddScript() {
    useEffect(() => {
        const script = document.createElement('script');

        const form = document.createElement('form');
        const btn_script = document.createElement('script');

        btn_script.src = "https://checkout.razorpay.com/v1/payment-button.js";
        btn_script.setAttribute("data-payment_button_id", "pl_OAd1Lxkl8a9mBn");
        btn_script.async = true;

        form.appendChild(btn_script)
        form.setAttribute("style", "display: none;");
        
        script.innerHTML = `setTimeout(function(){
            console.log("Working")
            Array.from(document.getElementsByClassName('cta-btn')).forEach((el) => {
                el.addEventListener('click', () => {
                  document.querySelector('a.PaymentButton').click();
                })
            });
            Array.from(document.getElementsByClassName('cta')).forEach((el) => {
                el.addEventListener('click', () => {
                  document.querySelector('a.PaymentButton').click();
                })
            });
          }, 100)`;
      
        document.body.appendChild(form);
        document.body.appendChild(script);
      
        return () => {
            document.body.removeChild(form);
            document.body.removeChild(script);
        }
      }, []);
}

export default AddScript
